export const TICKET_STATUSES = {
  OPEN: 'Open',
  PENDING: 'Pending',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
  WAITING_ON_CUSTOMER: 'Waiting on Customer',
  WAITING_ON_OPERATION: 'Waiting on Operation',
  WAITING_ON_PAYMENTS_AND_GE: 'Waiting on Payments/GE',
};
